<template>
  
  <div style="width:98%;margin:0 auto">

    <div class="mb-2 d-flex" style="align-items:center">
      <div class=" d-flex"  style="align-items:center">
         <span class="mr-3">{{newDate}}</span>
      <el-form inline ref="form" :model="searchform">
         <el-form-item class="mb-0 mr-0">
         {{$t('msg.하위포함')}} <el-checkbox true-label="1" false-label="0" @change="fetchManage()" v-model="searchform.xia" style="margin:0 5px;"></el-checkbox>
  
          </el-form-item>
          <el-form-item  class="mb-0 mr-0">
             <el-date-picker
                  v-model="searchform.time"
                  type="daterange"
                  range-separator="~"
                   :start-placeholder="$t('searchText.시작')"
                  :end-placeholder="$t('searchText.마감')"  size="mini"  value-format="yyyy-MM-dd" style="width:200px" >
                </el-date-picker>
          </el-form-item>

          <!-- <el-form-item class="mb-0 mr-0">
             <el-select v-model="searchform.value" placeholder="타이틀선택" size="mini" style="width:100px;">
               <el-option
                      v-for="item in searchform.searchOptions"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value">
                    </el-option>
              </el-select>
          </el-form-item>-->

          <el-form-item class="mb-0 mr-0">
            <el-button type="info" size="mini" @click="searchEvent">{{$t('searchText.검색')}}</el-button>  
  
          </el-form-item>
          
      </el-form>
    <span class="ml-3 text-danger">{{tips}}</span>
  </div>
     <!--<el-button type="default" size="mini" class="ml-auto" @click="back()" style="height:29px;line-height:29px;padding:0 10px">back</el-button> -->
       
    
    </div>
     <table class="table  bubTable" style="width:100%;" v-loading="loading">
            <thead>
              <tr>
                <th scope="col" class="text-center">{{$t('msg.아이디')}}</th>
                <th scope="col" class="text-center">{{$t('tableText.타입')}}</th>
                <th scope="col" class="text-center">{{$t('tableText.현잔액')}}</th>
                <th scope="col" class="text-center">{{$t('tableText.현카슬')}}</th>
                <th scope="col" class="text-center">{{$t('tableText.현롤링')}}</th>
                <th scope="col" class="text-center">{{$t('msg.충전')}}</th>
                <th scope="col" class="text-center">{{$t('msg.환전')}}</th>
                <th scope="col" width="120" class="text-center">{{$t('msg.수동충전')}}</th>
                <th scope="col" class="text-center">{{$t('msg.수동환전')}}</th>
                <th scope="col" class="text-center">{{$t('msg.입금출금')}}</th>

                <th scope="col" class="text-center">{{$t('msg.슬롤링')}}</th>
                <th scope="col" class="text-center">{{$t('msg.카롤링')}}</th>
                 <th scope="col" class="text-center">{{$t('msg.파롤링')}}</th>

                <th scope="col" class="text-center">{{$t('msg.롤링합계')}}</th>
                <th scope="col" class="text-center">{{$t('msg.롤링전환')}}</th>


                <th scope="col" class="text-center">{{$t('msg.슬배팅')}}</th>
                 <th scope="col" class="text-center">{{$t('msg.슬당첨')}}</th>
                   <th scope="col" class="text-center">{{$t('msg.카배팅')}}</th>
                 <th scope="col" class="text-center">{{$t('msg.카당첨')}}</th>
               
                  <th scope="col" class="text-center">{{$t('msg.파배팅')}}</th>
                 <th scope="col" class="text-center">{{$t('msg.파당첨')}}</th>

                <th scope="col" class="text-center">{{$t('tableText.배팅금')}}</th>
                <th scope="col" class="text-center">{{$t('tableText.당첨금')}}</th>
                <th scope="col" class="text-center">{{$t('msg.배팅당첨')}}</th>

                <th scope="col" class="text-center">{{$t('msg.수익')}}</th>

                <th scope="col" class="text-center">{{$t('msg.슬루징')}}</th>
                <th scope="col" class="text-center">{{$t('newAdd.카루징')}}</th>
              
              </tr>
            </thead>
            <tbody v-for="(item,index) in tableData" :key="index" :index="index">

              <tr>
               
                     <td style="vertical-align: middle;" align="center">
                      <span class="text-primary">{{item.mem_id}}</span>
                     
                    </td>
                     
                     <td align="center" @click="openShopModel(item.mem_id)"  class="slot"><a class="text-primary" style="cursor:pointer;text-decoration:underline">{{item.type}}</a></td>
                     <td width="150" align="center" class="slot">{{formatMoney(item.mem_cash)}}</td>
                     <td width="150" align="center" class="slot">{{formatMoney(item.api_money)}}</td>
                      <td width="150" align="center" class="slot">{{formatMoney(item.mem_ecash)}}</td>
                     <td width="150" align="center" class="slot">{{formatMoney(item.tt1)}}</td>
                     <td width="150"   align="center" class="slot">{{formatMoney(item.tt2)}}</td>
                     <td width="150" align="center" class="slot">{{formatMoney(item.tt3)}}</td>
                     <td width="150" align="center" class="slot">{{formatMoney(item.tt4)}}</td>
                     <td width="150" align="center" class="slot">{{formatMoney(item.tt5)}}</td>

                     <td align="center" class="slot">{{formatMoney(item.tt6)}}</td>
                     <td align="center" class="slot">{{formatMoney(item.tt7)}}</td>

                     <td  align="center" class="slot">{{formatMoney(item.tt8)}}</td>

                     <td align="center" class="slot">{{formatMoney(item.tt678)}}</td>
                     <td align="center" class="slot">{{formatMoney(item.tt9)}}</td>

                     <td align="center" class="slot">{{formatMoney(item.tt10)}}</td>
                     <td align="center" class="slot">{{formatMoney(item.tt11)}}</td>

                     <td align="center" class="slot">{{formatMoney(item.tt12)}}</td>
                     <td align="center" class="slot">{{formatMoney(item.tt13)}}</td>

                     <td align="center" class="slot">{{formatMoney(item.tt14)}}</td>
                     <td align="center" class="slot">{{formatMoney(item.tt15)}}</td>

                     <td align="center" class="slot">{{formatMoney(item.tt16)}}</td>
                     <td align="center" class="slot">{{formatMoney(item.tt17)}}</td>
                    <td align="center" class="slot">{{formatMoney(item.tt1617)}}</td>

                       <td align="center" class="slot">{{formatMoney(item.tt1617-item.tt678)}}</td>

                     <td align="center" class="slot">{{formatMoney(item.slot_rosing)}} ({{item.pc_slot}})</td>
                    <td align="center" class="slot">{{formatMoney(item.e_rosing)}} ({{item.pc_e}})</td>
                 

               
              

              </tr>
           
            </tbody>
         </table>
          
  </div>
</template>
<script>
 import shopDialog from './shop-dialog.vue';
 import '../../assets/layerstyle.css'

  export default{
     components: {
     
      shopDialog,
    
    },
    props:{
      //接收父组件传来的id值
      info:{
        type:Object,
        default:()=>{
          return {}
        }
      },
       layerid:{
        type:String,
        default:""
      },
    
    },
    computed: {
          
          
            
        },
      data(){
        return{
          back_id:'',
          boss:'',
          tips:'',
          newDate:'',
          v:'',
           domain:window.sessionStorage.getItem('domain'),
           admin_id:window.sessionStorage.getItem('admin_id'),
           power:window.sessionStorage.getItem('power'),
            loading:false,
            tableData:[],
            total:0,
            size:0,
            currentPage:1,
            searchform:{
            xia:'1',
            time:[],
            searchOptions:[
                
            {
             label:this.$i18n.t("nav.아이디"),
              value:'mem_id'
            },
            

            ],
           
            value:'',
          },
             pickerOptions: {
          },
          shortcuts: [{
            text:this.$i18n.t("dateText.최근한주"),
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit('pick', [start, end]);
            }
          }, {
            text:this.$i18n.t("dateText.최근한달"),
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit('pick', [start, end]);
            }
          }, {
            text:this.$i18n.t("dateText.최근3개월"),
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
              picker.$emit('pick', [start, end]);
            }
          }],
        
           
          
        }
      },
      created() {
         // this.info.id父组件传给子组件的id值

         //this.v = this.info.id
         this.fetchManage();
         

          
             
    },
    
      methods:{
         openShopModel(id){

          if(id=='합계')
          {
             return;
          }

           this.$layer.iframe({
            type: 2,
            title: '',
            content: {
                content: shopDialog,
                parent: this,
                data:{
                info:{id:id},
                layerid:'id'
                }
              
            },
            success: function(layero, index) {
              //对加载后的iframe进行宽高度自适应
                //layer.iframeAuto(index);
            },
            shadeClose: false,
             maxmin : true,

            shade: false,
            area: ['1100px','600px'],
           
        });
        
        },

        back()
        {
            // history.go(-1)
        },

        habu(id){
          if(id=='this.$i18n.t("msg.합계")')
          {
             return;
          }
          //this.boss=id
          this.info.id=id
          this.fetchManage();
        },
        fetchManage(){
          
               let s_time="";
               let e_time="";

               if(this.searchform.time.length>0)
               {
                  s_time=this.searchform.time[0];
                  e_time=this.searchform.time[1];
               }

           this.loading =true
           let token=window.sessionStorage.getItem('user');

           //this.back_id=this.info.id
            
           let urls=this.domain+'/admin/calculation_id?xia='+this.searchform.xia+'&boss='+this.boss+'&mem_id='+this.info.id+'&s_time='+s_time+'&e_time='+e_time;
           if(this.boss!='')
           {
              urls=this.domain+'/admin/calculation_ids?xia='+this.searchform.xia+'&boss='+this.boss+'&mem_id='+this.info.id+'&s_time='+s_time+'&e_time='+e_time;
           }

           //this.back_id=urls



          this.$axios({
                  method:'get',
                  url:urls,
                  'Accept': 'application/json',
                   headers: { 'Authorization': 'Bearer ' + token },
                
               
            }).then((response) =>{ 

                    this.loading = false
                    console.log('tableData=',response.data.data)
                     let data = response.data
                     this.tableData =data.data
                     this.newDate =data.che_time
                     this.tips = data.tips
                     // this.total = data.total
                     // this.currentPage = data.current_page
                     // this.size =data.per_page
                     
                    
               
            }).catch((error) =>{
              
               this.$message.error(error);
              this.loading = false
                //console.log('error',error.response)       //请求失败返回的数据
               
            })
        },
      
      searchEvent(){
        this.fetchManage()
      },

      }
  }
</script>
<style scoped>

</style>


// WEBPACK FOOTER //
// src/components/common/shop-dialog.vue